import React, { useState } from 'react';
import { FaEye } from "react-icons/fa";
import ModalRejected from './ModalRejected';

function Rejected({ consultations = [] }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedConsultation, setSelectedConsultation] = useState(null);

   // Helper to format date as dd-mm-yy
   const formatDate = (isoString) => {
    if (!isoString) return ""; // or "N/A"
    const dateObj = new Date(isoString);
    if (isNaN(dateObj)) return "";

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear().toString().slice(-2);
    return `${day}/${month}/${year}`;
  };

  // Helper to format time in AM/PM
  const formatTime = (time) => {
    if (!time) return ""; // or "N/A"
    const [hours, minutes] = time.split(":");
    const parsedHours = parseInt(hours, 10);
    const ampm = parsedHours >= 12 ? "PM" : "AM";
    const formattedHours = parsedHours % 12 || 12; // Convert to 12-hour format
    return `${formattedHours}:${minutes} ${ampm}`;
  };

  const openModal = (consultation) => {
    setSelectedConsultation(consultation);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedConsultation(null);
  };

  return (
    <div className="px-10 py-6 bg-white rounded">
      <table className="w-full table-auto border-t border-b border-gray-300">
        <thead>
          <tr className="border-b border-gray-300">
            <th className="px-4 py-2 text-center text-gray-400">Consultation ID</th>
            <th className="px-4 py-2 text-center text-gray-400">Name</th>
            <th className="px-4 py-2 text-center text-gray-400">Email</th>
            <th className="px-4 py-2 text-center text-gray-400">Date</th>
            <th className="px-4 py-2 text-center text-gray-400">Time</th>
            <th className="px-4 py-2 text-center text-gray-400">Action</th>
          </tr>
        </thead>
        <tbody>
          {consultations.length > 0 ? (
            consultations.map((consultation) => (
              <tr
                key={consultation.consultationId}
                className="border-b border-gray-300 text-center"
              >
                <td className="px-4 py-4 text-sm text-gray-700">{consultation.consultationId}</td>
                <td className="px-4 py-4 text-sm text-gray-700">{consultation.studentName}</td>
                <td className="px-4 py-4 text-sm text-gray-700">{consultation.email}</td>
                <td className="px-4 py-4 text-sm text-gray-700">{formatDate(consultation.consultationDate)}</td>
                <td className="px-4 py-4 text-sm text-gray-700">{formatTime(consultation.consultationTime)}</td>
                
                <td className="px-4 py-4 text-sm text-gray-700">
                  <div className="flex items-center justify-center">
                    <FaEye
                      className="text-blue-500 hover:text-blue-600 cursor-pointer w-5 h-5"
                      onClick={() => openModal(consultation)}
                    />
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="px-4 py-4 text-sm text-gray-700 text-center">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {isModalOpen && (
        <ModalRejected
          isOpen={isModalOpen}
          onClose={closeModal}
          consultation={selectedConsultation}
        />
      )}
    </div>
  );
}

export default Rejected;